import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useLayoutEffect,
  useMemo,
} from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import Header from "../../layout/Header/Header";

import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Form,
  Card,
  CardHeader,
  CardText,
  CardBody,
} from "reactstrap";
import moment from "moment";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";
import * as am5percent from "@amcharts/amcharts5/percent";

function DashboardInventarios() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;
  const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  let anos = new Date();
  anos.setDate(anos.getDate() - 3650);
  const year = anos.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);

  const [info, setInfo] = useState([]);
  const [graficasColecciones, setGraficasColecciones] = useState([]);
  const [graficasLineas, setGraficasLineas] = useState([]);
  const [graficasFamilias, setGraficasFamilias] = useState([]);
  const [graficasAreas, setGraficasAreas] = useState([]);
  const [graficasAnos, setGraficasAnos] = useState([]);
  const [valorInventario, setValorInventario] = useState(0);
  const [cantidadInventario, setCantidadInventario] = useState(0);

  const [selectedAno, setSelectedAno] = useState("");
  const [colecciones, setColecciones] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [lineas, setLineas] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [selectedColeccion, setSelectedColeccion] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [cargando, setCargando] = useState(true);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      icon: "success",
      title: "Danos unos segundos....",
    });
  }

useEffect(()=>{
  axios
  .get(`${URL_DASHBOARDS}Inventarios`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allDisponible = response.data;
    let array = allDisponible
      .map((a) => {
        if (a.disponible > 0) {
          return a;
        }
      })
      .filter(function (el) {
        return el != null;
      });
      setInfo(array)
      
      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });

    axios
    .get(URL_PROVEEDORES, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allProveedores = res.data;
      setProveedores(allProveedores);
    })
    .catch((err) => {
      console.log(err);
    });

    axios
    .get(URL_COLECCIONES, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allColecciones = res.data;
      setColecciones(allColecciones);
    })
    .catch((err) => {
      console.log(err);
    });

    axios
    .get(URL_FAMILIAS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allFamilias = res.data;
      setFamilias(allFamilias);
    })
    .catch((err) => {
      console.log(err);
    });

    axios
    .get(URL_LINEAS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allLineas = res.data;
      setLineas(allLineas);
    })
    .catch((err) => {
      console.log(err);
    });

},[])


  useMemo(() => {
      let temp = info
          if (selectedAno) {
            temp = temp.filter((e) =>
              e.ano.includes(selectedAno)
            );
          }
          if (selectedColeccion) {
            temp = temp.filter((e) =>
              e.idColeccion.includes(selectedColeccion)
            );
          }
          if (selectedFamilia) {
            temp = temp.filter((e) =>
              e.idFamilia.includes(selectedFamilia)
            );
          }
          if (selectedLinea) {
            temp = temp.filter((e) =>
              e.idLinea.includes(selectedLinea)
            );
          }
          if (selectedProveedor) {
            temp = temp.filter((e) =>
              e.idProveedor.includes(selectedProveedor)
            );
          }

        let agrupadoColeccion = temp.reduce(function (groups, item) {
          const val = item["idColeccion"];
          groups[val] = groups[val] || {
            idColeccion: item.idColeccion,
            disponible: 0,
          };
          groups[val].disponible += item.disponible;
          groups[val].coleccion = item.coleccion;
          groups[val].idColeccion = item.idColeccion;
          return groups;
        }, []);

        let otraColeccion = Object.values(agrupadoColeccion).sort((a, b) =>
          a.disponible < b.disponible ? 1 : -1
        );

        setGraficasColecciones(otraColeccion);

        let agrupadoLinea = temp.reduce(function (groups, item) {
          const val = item["idLinea"];
          groups[val] = groups[val] || {
            idLinea: item.idLinea,
            disponible: 0,
          };
          groups[val].disponible += item.disponible;
          groups[val].linea = item.linea;
          groups[val].idLinea = item.idLinea;
          return groups;
        }, []);

        let otraLinea = Object.values(agrupadoLinea).sort((a, b) =>
          a.disponible < b.disponible ? 1 : -1
        );

        setGraficasLineas(otraLinea);

        let agrupadoFamilia = temp.reduce(function (groups, item) {
          const val = item["idFamilia"];
          groups[val] = groups[val] || {
            idFamilia: item.idFamilia,
            disponible: 0,
          };
          groups[val].disponible += item.disponible;
          groups[val].familia = item.familia;
          groups[val].idFamilia = item.idFamilia;
          return groups;
        }, []);

        let otraFamilia = Object.values(agrupadoFamilia).sort((a, b) =>
          a.disponible < b.disponible ? 1 : -1
        );

        setGraficasFamilias(otraFamilia);

        let agrupadoArea = temp.reduce(function (groups, item) {
          const val = item["idArea"];
          groups[val] = groups[val] || {
            idArea: item.idArea,
            disponible: 0,
          };
          groups[val].disponible += item.disponible;
          groups[val].area = item.area;
          groups[val].idArea = item.idArea;
          return groups;
        }, []);

        let otraArea = Object.values(agrupadoArea).sort((a, b) =>
          a.disponible < b.disponible ? 1 : -1
        );

        setGraficasAreas(otraArea);

        let agrupadoAno = temp.reduce(function (groups, item) {
          const val = item["ano"];
          groups[val] = groups[val] || {
            ano: item.ano,
            disponible: 0,
          };
          groups[val].disponible += item.disponible;
          groups[val].ano = item.ano;
          return groups;
        }, []);

        let otraAno = Object.values(agrupadoAno).sort((a, b) =>
          a.disponible < b.disponible ? 1 : -1
        );

        setGraficasAnos(otraAno);

        let TVal = temp.map((c) => parseFloat(c.valor));
        let TV = TVal.reduce((t, total, index) => t + total, 0);
        setValorInventario(TV);

        let TCan = temp.map((c) => parseFloat(c.disponible));
        let TC = TCan.reduce((t, total, index) => t + total, 0);
        setCantidadInventario(TC);

  }, [info, selectedAno, selectedColeccion, selectedFamilia, , selectedProveedor]);


  useLayoutEffect(() => {
    
    // Grafica Colecciones
    let root = am5.Root.new("chartdiv");

    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        endAngle: 270,
        layout: root.verticalLayout,
        tooltip: am5.Tooltip.new(root, {
          labelText: "{coleccion} {value}",
        }),
      })
    );

    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "disponible",
        categoryField: "coleccion",
        endAngle: 270,
      })
    );

    series.states.create("hidden", {
      endAngle: -90,
    });

    chart.children.unshift(
      am5.Label.new(root, {
        text: "Colecciones",
        fontSize: 25,
        fontWeight: "500",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(50),
        paddingTop: 0,
        paddingBottom: 0,
      })
    );

    series.labels.template.set("forceHidden", true);
    series.ticks.template.setAll({
      visible: false,
      stroke: am5.color("rgb(252, 252, 252)"),
    });
    series.data.setAll(graficasColecciones);
    series.appear(1000, 100);

    let legend = chart.children.push(
      am5.Legend.new(root, {
        nameField: "coleccion",
      })
    );

    legend.data.setAll(series.dataItems);

    // Grafica Lineas
    let rootLineas = am5.Root.new("chartdivLineas");

    rootLineas.setThemes([am5themes_Animated.new(rootLineas)]);

    let chartLineas = rootLineas.container.children.push(
      am5percent.PieChart.new(rootLineas, {
        endAngle: 270,
        layout: root.verticalLayout,
        tooltip: am5.Tooltip.new(rootLineas, {
          labelText: "{linea} {value}",
        }),
      })
    );

    let seriesLineas = chartLineas.series.push(
      am5percent.PieSeries.new(rootLineas, {
        valueField: "disponible",
        categoryField: "linea",
        endAngle: 270,
      })
    );

    seriesLineas.states.create("hidden", {
      endAngle: -90,
    });

    chartLineas.children.unshift(
      am5.Label.new(rootLineas, {
        text: "Lineas",
        fontSize: 25,
        fontWeight: "500",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(50),
        paddingTop: 0,
        paddingBottom: 0,
      })
    );

    seriesLineas.labels.template.set("forceHidden", true);
    seriesLineas.ticks.template.setAll({
      visible: false,
      stroke: am5.color("rgb(252, 252, 252)"),
    });
    seriesLineas.data.setAll(graficasLineas);
    seriesLineas.appear(1000, 100);

    let legendLineas = chartLineas.children.push(
      am5.Legend.new(rootLineas, {
        nameField: "linea",
      })
    );

    legendLineas.data.setAll(seriesLineas.dataItems);

    // Grafica Familias
    let rootFamilias = am5.Root.new("chartdivFamilias");

    rootFamilias.setThemes([am5themes_Animated.new(rootFamilias)]);

    let chartFamilias = rootFamilias.container.children.push(
      am5percent.PieChart.new(rootFamilias, {
        endAngle: 270,
        layout: root.verticalLayout,
        tooltip: am5.Tooltip.new(rootFamilias, {
          labelText: "{familia} {value}",
        }),
      })
    );

    let seriesFamilias = chartFamilias.series.push(
      am5percent.PieSeries.new(rootFamilias, {
        valueField: "disponible",
        categoryField: "familia",
        endAngle: 270,
      })
    );

    seriesFamilias.states.create("hidden", {
      endAngle: -90,
    });

    chartFamilias.children.unshift(
      am5.Label.new(rootFamilias, {
        text: "Familias",
        fontSize: 25,
        fontWeight: "500",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(50),
        paddingTop: 0,
        paddingBottom: 0,
      })
    );

    seriesFamilias.labels.template.set("forceHidden", true);
    seriesFamilias.ticks.template.setAll({
      visible: false,
      stroke: am5.color("rgb(252, 252, 252)"),
    });
    seriesFamilias.data.setAll(graficasFamilias);
    seriesFamilias.appear(1000, 100);

    let legendFamilias = chartFamilias.children.push(
      am5.Legend.new(rootFamilias, {
        nameField: "familia",
      })
    );

    legendFamilias.data.setAll(seriesFamilias.dataItems);


    // Grafica Años
     let rootAnos = am5.Root.new("chartdivAnos");

     rootAnos.setThemes([am5themes_Animated.new(rootAnos)]);
 
     let chartAnos = rootAnos.container.children.push(
       am5percent.PieChart.new(rootAnos, {
         endAngle: 270,
         layout: root.verticalLayout,
         tooltip: am5.Tooltip.new(rootAnos, {
           labelText: "{ano} {value}",
         }),
       })
     );
 
     let seriesAnos = chartAnos.series.push(
       am5percent.PieSeries.new(rootAnos, {
         valueField: "disponible",
         categoryField: "ano",
         endAngle: 270,
       })
     );
 
     seriesAnos.states.create("hidden", {
       endAngle: -90,
     });
 
     chartAnos.children.unshift(
       am5.Label.new(rootAnos, {
         text: "Años",
         fontSize: 25,
         fontWeight: "500",
         textAlign: "center",
         x: am5.percent(50),
         centerX: am5.percent(50),
         paddingTop: 0,
         paddingBottom: 0,
       })
     );
 
     seriesAnos.labels.template.set("forceHidden", true);
     seriesAnos.ticks.template.setAll({
       visible: false,
       stroke: am5.color("rgb(252, 252, 252)"),
     });
     seriesAnos.data.setAll(graficasAnos);
     seriesAnos.appear(1000, 100);
 
     let legendAnos = chartAnos.children.push(
       am5.Legend.new(rootAnos, {
         nameField: "ano",
       })
     );
 
     legendAnos.data.setAll(seriesAnos.dataItems);

    // Grafica Areas

    let rootAreas = am5.Root.new("chartdivAreas");

    rootAreas.setThemes([am5themes_Animated.new(rootAreas)]);

    let chartAreas = rootAreas.container.children.push(
      am5xy.XYChart.new(rootAreas, {
        panY: false,
        layout: rootAreas.verticalLayout,
      })
    );

    let dataAreas = graficasAreas;

    // Create Y-axis
    let yAxis = chartAreas.yAxes.push(
      am5xy.ValueAxis.new(rootAreas, {
        renderer: am5xy.AxisRendererY.new(rootAreas, {}),
      })
    );

    // Create X-Axis
    let xAxis = chartAreas.xAxes.push(
      am5xy.CategoryAxis.new(rootAreas, {
        renderer: am5xy.AxisRendererX.new(rootAreas, {}),
        categoryField: "area",
      })
    );
    xAxis.data.setAll(dataAreas);

    // Create series
    let seriesAreas = chartAreas.series.push(
      am5xy.ColumnSeries.new(rootAreas, {
        name: "area",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "disponible",
        categoryXField: "area",
        tooltip: am5.Tooltip.new(rootAreas, {
          labelText: "{area} {valueY}",
        }),
      })
    );
    seriesAreas.data.setAll(dataAreas);

    // Add cursor
    chartAreas.set("cursor", am5xy.XYCursor.new(rootAreas, {}));

    let exporting = am5plugins_exporting.Exporting.new(rootAreas, {
      menu: am5plugins_exporting.ExportingMenu.new(rootAreas, {}),
    });

    chartAreas.children.unshift(
      am5.Label.new(rootAreas, {
        text: "Almacenes",
        fontSize: 25,
        fontWeight: "500",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(50),
        paddingTop: 0,
        paddingBottom: 0,
      })
    );

    return () => {
      root.dispose();
      rootLineas.dispose();
      rootFamilias.dispose();
      rootAreas.dispose();
      rootAnos.dispose();
    };
  }, [graficasColecciones, graficasLineas, graficasFamilias, graficasAreas, graficasAnos]);

  return (
    <>
      <Header />
      <br />
      <br />
      {/* {user.menu_disponible ? ( */}
      <div className="card container col-12">
        <Row>
          <Col md={8}>
            <Button
              size="sm"
              href="/Dashboards"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Col>
        </Row>
        <h3 align="center">Dashboard Inventarios</h3>
          <Row>

      <Col md={1}>
      <Label className="mr-sm-2">Años</Label>
           <Input
                  bsSize="sm"
                  type="select"
                  value={selectedAno}
                  onChange={(e) => {
                    setSelectedAno(e.target.value);
                  }}
                >
                 <option value="0">Selecciona</option>
                {years.map((a) => {
                  return <option value={a}>{a}</option>;
                })}
                </Input>
                </Col>

                <Col md={2}>
              <Label className="mr-sm-2">Colecciones</Label>
              <Input
                
                bsSize="sm"
                type="select"
                value={selectedColeccion}
                required
                onChange={(e) => {
                  setSelectedColeccion(e.target.value);
                }}
              >
                <option value="0">Selecciona</option>
                {colecciones
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={2}>
              <Label className="mr-sm-2">Familias</Label>
              <Input
                
                bsSize="sm"
                type="select"
                value={selectedFamilia}
                required
                onChange={(e) => {
                  setSelectedFamilia(e.target.value);
                }}
              >
                <option value="0">Selecciona</option>
                {familias
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={2}>
              <Label className="mr-sm-2">Lineas</Label>
              <Input
                
                bsSize="sm"
                type="select"
                value={selectedLinea}
                required
                onChange={(e) => {
                  setSelectedLinea(e.target.value);
                }}
              >
                <option value="0">Selecciona</option>
                {lineas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={2}>
              <Label className="mr-sm-2">Proveedor</Label>
              <Input
                
                bsSize="sm"
                type="select"
                value={selectedProveedor}
                required
                onChange={(e) => {
                  setSelectedProveedor(e.target.value);
                }}
              >
                <option value="0">Selecciona</option>
                {proveedores
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>

        {/*   <Col md={2}>
            <Label className="mr-sm-2">Fecha Inicio</Label>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaInicio}
              required
              onChange={(e) => {
                setSelectedFechaInicio(e.target.value)
                setCargando(true)
              }}
            />
          </Col>
          <Col md={2}>
            <Label className="mr-sm-2">Fecha Fin</Label>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaFin}
              required
              onChange={(e) => {
                setSelectedFechaFin(e.target.value)
                setCargando(true)
              }}
            />
          </Col>*/}

        </Row> 

        <div
        className="container"
        style={{ display: "flex", justifyContent: "center" }}
        a
      >
        <Col md={3}>
          <Card>
            <CardHeader tag="h3" align="center">
              Piezas 
            </CardHeader>
            <CardBody>
              <CardText tag="h4" align="center">
                {new Intl.NumberFormat("en-US", {}).format(cantidadInventario)}
              </CardText>
            </CardBody>
          </Card>
        </Col>

        <Col md={3}>
          <Card>
            <CardHeader tag="h3" align="center">
              Valor 
            </CardHeader>
            <CardBody>
              <CardText tag="h4" align="center">
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(valorInventario)}
              </CardText>
            </CardBody>
          </Card>
        </Col>
      </div>

      
        <div
          // className="container"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div id="chartdiv" style={{ width: "40%", height: "500px" }}></div>
          <div
            id="chartdivLineas"
            style={{ width: "40%", height: "500px" }}
          ></div>
        </div>

        <br />
        <br />
        <div
          // className="container"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div
            id="chartdivFamilias"
            style={{ width: "40%", height: "500px" }}
          ></div>

          <div
            id="chartdivAnos"
            style={{ width: "40%", height: "500px" }}
          ></div>
        </div>

        <br />
        <br />
        <div
          // className="container"
          style={{ display: "flex", justifyContent: "center" }}
        >

          <div
            id="chartdivAreas"
            style={{ width: "90%", height: "500px" }}
          ></div>
        </div>


      </div>


      {/* ) : undefined}  */}
    </>
  );
}
export default DashboardInventarios;
